import axios from 'axios';
import configData from '../config.json';

// Stampcard V2 §6.5 — the conversion ramp.
//
// A guest who scanned a venue QR carries a signed wallet token in
// `hw-wallet-token` (see context/stampWallet.js). The moment that device
// authenticates, the guest's stamps and vouchers have to be re-pointed onto the
// account, and the guest token cleared so it can never shadow the (richer)
// account wallet afterwards.
//
// Lives in one place because every auth entry point needs it: the Navbar login /
// signup / Google / Facebook handlers, and the standalone /login and /register
// pages.
//
// Non-blocking and fail-safe by contract: a merge failure must NEVER block a
// login or a redirect. The returned promise always resolves, so callers that
// navigate afterwards can sequence on it (`.finally(...)`) to make sure the POST
// is at least dispatched before the page is torn down.
export const mergeGuestWallet = (newToken) => {
  let walletToken = null;
  try {
    walletToken = localStorage.getItem('hw-wallet-token');
  } catch (e) {
    walletToken = null;
  }
  if (!walletToken || !newToken) return Promise.resolve();

  return axios
    .post(
      `${configData.SERVER_URL}/stamp/wallet/merge`,
      { walletToken },
      { headers: { Authorization: `Bearer ${newToken}` } },
    )
    .catch((error) => {
      // Swallow — merge is best-effort and must not block the auth flow.
      console.log('Guest wallet merge:', error.message);
    })
    .finally(() => {
      // Clear the guest wallet token regardless of the merge outcome
      // (single-device wallet).
      try {
        localStorage.removeItem('hw-wallet-token');
      } catch (e) {
        /* ignore */
      }
    });
};

export default mergeGuestWallet;
